// @flow
import type { Player$Translation } from '../types/Translation';

const i18n: Player$Translation = {
   fullscreen: 'Fullscreen',
   'exit-fullscreen': 'Exit full screen',

   theater: 'Theater mode',
   'exit-theater': 'Standard mode',

   play: 'Play',
   pause: 'Pause',
   replay: 'Replay',
   'standard-playbackrate': 'Standard',
   forward: 'Forward 10 sec',
   backward: 'Back 10 sec',
   prevframe: 'Move to previous frame',
   nextframe: 'Move to next frame',
   annotations: 'Annotations',
   quality: 'Quality',
   'audio-tracks': 'Audio tracks',
   'playback-rate': 'Playback rate',
   settings: 'Settings',
   buffering: 'Buffering...',
   cc: 'Closed Captions',
   transcript: 'Transcript',
   chapters: 'Chapters',
   back: 'Back',
   'settings-fontcolor': 'Font color',
   'settings-fontsize': 'Font size',
   'settings-fontfamily': 'Font family',
   'settings-background': 'Background color',
   'settings-captionlocations': 'Captions location',
   help: 'Help',
   download: 'Download',
   'video-drm': 'Video',
   'video-only': 'Video Only',
   'video-and': 'Video and',
   language: 'Language',

   'unapproved-source': '(unapproved)',
   translate: 'Translate',
   translating: 'Translating...',

   monoserif  : 'Monospace serif',
   propserif  : 'Proportionate serif',
   monosans   : 'Monospace sans serif',
   propssans  : 'Proportionate sans serif',

   'cc-location-over'    : 'Overlay video',
   'cc-location-below'   : 'Below the video',

   red     : 'Red',
   purple  : 'Purple',
   indigo  : 'Indigo',
   blue    : 'Blue',
   green   : 'Green',
   yellow  : 'Yellow',
   orange  : 'Orange',
   brown   : 'Brown',
   grey    : 'Grey',
   white   : 'White',
   black   : 'Black',

   'help-bacward'  : '"Left (◄)" - Jump backward by 10 seconds',
   'help-play'     : '"Space" - Toggle playback',
   'help-skip'     : '"Right (►)" - Skip 10 seconds',
   'help-volume'   : '"UP/DOWN (▲/▼)" - Change volume by 10%',
   'help-esc'      : '"ESC" - exit fullscreen',

   'no-video'      : 'No playable sources found',
   'no-flash'      : 'For watching video you need to install Flash Player and restart your browser',
   'playlist-count-of': 'videos',

   'caption-search': 'Search captions',

   c2pa: 'C2PA',
   'view-more': 'Learn more',
   'c2pa-invalid-claim': 'Content credentials are incomplete or missing',
   'c2pa-exception-subtitle': 'Unexpected error occurred while validating content provenance',
   'c2pa-unverified-claim': 'Content credentials are unverified',
   'c2pa-no-data-message': 'Video is missing provenance information. Video owner cannot be established',
   'c2pa-video-credentials-status': 'Video credentials status:',
   'c2pa-status-valid': 'Valid',
   'c2pa-status-invalid': 'Invalid',
   'c2pa-status-incomplete': 'Incomplete',
   'c2pa-status-unknown': 'Unknown',
   'c2pa-signature-valid': 'Digital signature is valid',
   'c2pa-signature-valid-extended': 'Digital signature is valid. All tracks pass validation and are signed by the owner.',
   'c2pa-issued-to': 'Issued to:',
   'c2pa-issued-by': 'Issued by:',
   'c2pa-encoded-by': 'Encoded by:',
   'c2pa-video-owner': 'Video owner:',
   'c2pa-signature-invalid': 'Content credentials have been changed, and authenticity cannot be verified',
   next: 'Next',
   prev: 'Previous',

   error: 'An error occurred while playing the media.'
};

export default i18n;
